
import { Link } from 'react-router-dom';

const EquipePage = () => {
  return (
    <div className="min-h-screen bg-[#F8F8F8] overflow-x-hidden" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {/* Floating Navigation */}
      <nav className="fixed top-6 left-1/2 transform -translate-x-1/2 z-50 bg-[#0F3F2F]/90 backdrop-blur-xl border border-[#C0C0C0]/30 rounded-full px-8 py-4 transition-all duration-500">
        <div className="flex items-center space-x-8">
          <div className="text-xl font-bold text-white" style={{ fontFamily: 'Cinzel Decorative, serif' }}>
            DLUXMEN
          </div>
          <div className="hidden lg:flex items-center space-x-6">
            <Link
              to="/"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-[#C0C0C0] hover:text-white hover:bg-white/10"
            >
              <i className="ri-home-line"></i>
              <span>Início</span>
            </Link>
            <Link
              to="/apresentacao"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-[#C0C0C0] hover:text-white hover:bg-white/10"
            >
              <i className="ri-play-circle-line"></i>
              <span>Experience</span>
            </Link>
            <Link
              to="/equipe"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-[#0F3F2F] bg-white"
            >
              <i className="ri-team-line"></i>
              <span>Team</span>
            </Link>
            <Link
              to="/produtos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-[#C0C0C0] hover:text-white hover:bg-white/10"
            >
              <i className="ri-fire-line"></i>
              <span>Produtos</span>
            </Link>
            <Link
              to="/contatos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-[#C0C0C0] hover:text-white hover:bg-white/10"
            >
              <i className="ri-phone-line"></i>
              <span>Contact</span>
            </Link>
          </div>
          <button
            onClick={() => window.open('https://wa.me/5511945589527?text=Olá!%20Quero%20conhecer%20os%20produtos%20DLUXMEN', '_blank')}
            className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white px-6 py-2 rounded-full text-sm font-semibold transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer shadow-lg shadow-green-500/25"
          >
            <i className="ri-whatsapp-line"></i>
            <span>WhatsApp</span>
          </button>
        </div>
      </nav>

      {/* Team Showcase */}
      <section className="py-32 bg-gradient-to-b from-[#F8F8F8] via-white to-[#F8F8F8] relative min-h-screen flex items-center">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <div className="inline-flex items-center bg-[#0F3F2F]/10 border border-[#0F3F2F]/30 rounded-full px-6 py-2 mb-8">
              <i className="ri-team-line text-[#0F3F2F] mr-2"></i>
              <span className="text-[#0F3F2F] text-sm font-medium">NOSSA EQUIPE</span>
            </div>
            
            <h2 className="text-6xl lg:text-7xl font-bold text-[#0B0B0B] mb-6" 
                style={{ fontFamily: 'Cinzel Decorative, serif' }}>
              Especialistas em<br />Atendimento Premium
            </h2>
            <p className="text-xl text-[#C0C0C0] max-w-3xl mx-auto">
              Conheça nossa equipe dedicada em oferecer a melhor experiência DLUXMEN
            </p>
          </div>
          
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
              {[
                {
                  name: 'Natan Israel',
                  role: 'Consultor de Vendas',
                  whatsapp: '5511945589527',
                  message: 'Atendimento+DLUXMEN',
                  description: 'Especialista em coleções masculinas e atendimento personalizado',
                  image: 'https://public.readdy.ai/ai/img_res/b372efb3f8b8e7887bc26b04c91af060.jpg'
                },
                {
                  name: 'Maria Eduarda',
                  role: 'Atendente / Consultora',
                  whatsapp: '5511914893837',
                  message: 'Atendimento+DLUXMEN',
                  description: 'Especialista em coleções femininas e experiência do cliente',
                  image: 'https://readdy.ai/api/search-image?query=Professional%20Brazilian%20female%20consultant%20in%20elegant%20dark%20green%20blazer%20smiling%20warmly%20in%20modern%20luxury%20retail%20environment%20with%20soft%20lighting%20and%20minimalist%20background%20high%20quality%20portrait%20photography%20style&width=400&height=400&seq=eduarda001&orientation=squarish'
                },
                {
                  name: 'Shayrom Rocha',
                  role: 'Vendas & Suporte',
                  whatsapp: '5511988428995',
                  message: 'Atendimento+DLUXMEN',
                  description: 'Especialista em logística e separação de produtos premium',
                  image: 'https://readdy.ai/api/search-image?query=Professional%20Brazilian%20logistics%20specialist%20man%20in%20elegant%20dark%20green%20shirt%20standing%20confidently%20in%20modern%20warehouse%20environment%20with%20luxury%20products%20and%20minimalist%20background%20high%20quality%20portrait%20photography%20style&width=400&height=400&seq=shayrom001&orientation=squarish'
                }
              ].map((member, index) => (
                <div key={index} className="group text-center bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-500 border border-[#C0C0C0]/20">
                  {/* Photo Container */}
                  <div className="relative mb-6">
                    <div className="relative w-32 h-32 mx-auto">
                      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#0F3F2F]/20 via-transparent to-[#C0C0C0]/20 p-1 group-hover:from-[#0F3F2F]/40 group-hover:to-[#C0C0C0]/40 transition-all duration-500">
                        <div className="w-full h-full rounded-full bg-gradient-to-br from-[#F8F8F8] to-white p-1">
                          <img
                            src={member.image}
                            alt={member.name}
                            className="w-full h-full object-cover object-center rounded-full group-hover:scale-105 transition-transform duration-500"
                          />
                        </div>
                      </div>
                      <div className="absolute -top-1 -right-1 w-4 h-4 bg-[#0F3F2F] rounded-full opacity-80 group-hover:scale-125 transition-transform duration-300"></div>
                    </div>
                  </div>
                  
                  {/* Name & Role */}
                  <div className="mb-4">
                    <h3 className="text-2xl font-bold text-[#0B0B0B] mb-2" 
                        style={{ fontFamily: 'Cinzel Decorative, serif' }}>
                      {member.name}
                    </h3>
                    <p className="text-[#0F3F2F] font-semibold text-lg mb-3">{member.role}</p>
                    <p className="text-[#C0C0C0] text-sm leading-relaxed">{member.description}</p>
                  </div>
                  
                  {/* Contact Button */}
                  <button
                    onClick={() => window.open(`https://wa.me/${member.whatsapp}?text=${member.message}`, '_blank')}
                    className="group/btn relative bg-[#0F3F2F] hover:bg-[#0F3F2F]/90 text-white px-6 py-3 rounded-full font-medium transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap w-full"
                  >
                    <div className="flex items-center justify-center space-x-2">
                      <i className="ri-whatsapp-line text-lg group-hover/btn:scale-110 transition-transform duration-300"></i>
                      <span>Conversar no WhatsApp</span>
                    </div>
                  </button>
                </div>
              ))}
            </div>
            
            {/* Store Information */}
            <div className="mt-20 bg-[#0F3F2F] rounded-3xl p-12 text-center">
              <div className="mb-8">
                <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Cinzel Decorative, serif' }}>
                  Visite Nossa Loja Física
                </h3>
                <p className="text-[#C0C0C0] text-lg">
                  Experimente nossos produtos pessoalmente na Feira da Madrugada
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                <div className="bg-white/10 rounded-2xl p-6 backdrop-blur-sm">
                  <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-full mx-auto mb-4">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <h4 className="text-white font-semibold mb-2">Endereço</h4>
                  <p className="text-[#C0C0C0] text-sm">
                    Rua Monsenhor Andrade, 987 - Brás<br />
                    São Paulo - SP, CEP: 03009-100<br />
                    Corredor Principal Box L 1136 - 1º Andar<br />
                    Feira da Madrugada
                  </p>
                </div>
                
                <div className="bg-white/10 rounded-2xl p-6 backdrop-blur-sm">
                  <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-full mx-auto mb-4">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <h4 className="text-white font-semibold mb-2">Horário de Funcionamento</h4>
                  <p className="text-[#C0C0C0] text-sm">
                    Segunda a Sábado<br />
                    das 8h às 15h50
                  </p>
                </div>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="flex justify-center mt-16">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-px bg-gradient-to-r from-transparent via-[#0F3F2F]/50 to-transparent"></div>
                <div className="w-2 h-2 bg-[#0F3F2F]/60 rounded-full"></div>
                <div className="w-16 h-px bg-gradient-to-r from-[#0F3F2F]/50 via-[#0F3F2F]/80 to-[#0F3F2F]/50"></div>
                <div className="w-2 h-2 bg-[#0F3F2F]/60 rounded-full"></div>
                <div className="w-12 h-px bg-gradient-to-r from-transparent via-[#0F3F2F]/50 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F3F2F] text-white py-16 relative overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-6" 
                 style={{ fontFamily: 'Cinzel Decorative, serif' }}>
              DLUXMEN
            </div>
            <p className="text-[#C0C0C0] mb-12 text-lg">
              Onde cada detalhe faz diferença.
            </p>
            
            <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/20">
              <p className="text-[#C0C0C0] mb-4 md:mb-0">
                © 2025 DLUXMEN. Todos os direitos reservados.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C0C0C0] hover:text-white transition-colors text-sm"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Responsive Styles */}
      <style jsx>{`
        @media (max-width: 768px) {
          .container {
            padding-left: 1rem;
            padding-right: 1rem;
          }
          
          h2 {
            font-size: 3rem !important;
            line-height: 1.1;
          }
          
          .grid {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
          
          nav .hidden {
            display: none !important;
          }
          
          nav {
            padding: 1rem 1.5rem;
          }
          
          section {
            padding-top: 8rem;
            padding-bottom: 4rem;
          }
        }
      `}</style>
    </div>
  );
};

export default EquipePage;
